export const ApiConfig = {
  // host: '192.168.1.92:8000',
  host: 'office.hipointfinancial.com',
  protocol: 'https',
  apiKey: 'Lda7Iujk7DO2N7rsqtBeyYDFEdYCQKVy',
  pathPrefix: '',
};

export const StoreApiConfig = {
  host: '',
  protocol: '',
  appKey: '',
  pathPrefix: '',
};
